module.exports = __webpack_public_path__ + "static/media/footer_contrato_v2.1e22b6f2.jpeg";